import script from "./end.vue?vue&type=script&setup=true&lang=js"
export * from "./end.vue?vue&type=script&setup=true&lang=js"

import "./end.vue?vue&type=style&index=0&id=0c1fba56&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1fba56"]])

export default __exports__